module.exports = __webpack_public_path__ + "img/teacherPoster.65321dcd.jpg";